import { Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { Wrapper } from "./styles";
import CustomTabPanel from "./CustomTabPanel";
import React from "react";
import CharacteristicsTab from "./CharacteristicsTab";
import { Property } from "../../../../global/types";
import FaqsTab from "./FaqsTab";

interface IProps {
  property: Property;
}

function DescriptionTabs({ property }: IProps) {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };
  return (
    <Wrapper>
      <Tabs value={value} onChange={handleChange}>
        <Tab label="Descrições" id="simple-tab-0" />
        <Tab label="Perguntas Frequentes" id="simple-tab-1" />
      </Tabs>

      <CustomTabPanel value={value} index={0}>
        <CharacteristicsTab property={property} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <FaqsTab />
      </CustomTabPanel>
    </Wrapper>
  );
}

export default DescriptionTabs;
